import { useEffect, useRef } from 'react'
import type { Track } from 'livekit-client'

/**
 * Видео дорожки LiveKit в элементе <video>. Звука в нём нет: он идёт своим путём, через Web Audio.
 *
 * Живое видео на паузу не ставится. На телефоне паузу даёт сам браузер — родной полноэкранный плеер,
 * шторка с медиа, картинка в картинке, — а кнопки «продолжить» у нас нет: камера замирала насовсем.
 * Поэтому пауза тут же снимается, а картинка в картинке и вывод на другие устройства выключены.
 */
export function TrackVideo({ track, className }: { track: Track; className?: string | undefined }) {
  const ref = useRef<HTMLVideoElement | null>(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    track.attach(el)
    const resume = () => {
      if (el.isConnected) void el.play().catch(() => undefined)
    }
    el.addEventListener('pause', resume)
    return () => {
      el.removeEventListener('pause', resume)
      track.detach(el)
    }
  }, [track])
  return <video ref={ref} className={className} autoPlay playsInline muted disablePictureInPicture disableRemotePlayback />
}
